import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * 언어 변경 훅
 * @param language 변경할 언어 코드
 * @returns 현재 설정된 언어 코드
 */
export const useChangeLanguage = (language: string) => {
  // 최신 언어 설정값을 사용
  const [lang, setLang] = useState(language);
  const { i18n } = useTranslation();
  
  useEffect(() => {
    if (!language) return;
    
    setLang(language);
    
    // 언어 변경 적용
    i18n.changeLanguage(language);
    
    // 언어 설정을 localStorage에 저장
    localStorage.setItem('i18nextLng', language);
    
    // 쿠키에도 저장 (document.cookie 사용)
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1); // 1년 후 만료
    document.cookie = `i18nextLng=${language}; path=/; expires=${expirationDate.toUTCString()}; SameSite=Strict; secure=true`;
    
    // 디버깅용 로그
    console.log(`Language changed to: ${language}`);
    console.log(`localStorage i18nextLng: ${localStorage.getItem('i18nextLng')}`);
  }, [i18n, language]);
  
  return lang;
};
